import { configs } from '@/configs'
import { RedirectType } from 'next/dist/client/components/redirect'
import {
  redirect as redirectNext,
  usePathname,
  useRouter as useBaseRouter,
} from 'next/navigation'
import { NextResponse } from 'next/server'

export const basePathify = (url: string) => {
  return configs.BASE_PATH ? `${configs.BASE_PATH}${url}` : url
}

// /portal-emissora/login -> /login
// /login -> /login
export const basepathRemover = (path: string) => {
  return configs.BASE_PATH ? path.replace(configs.BASE_PATH, '') : path
}

export const useWithoutBasePathname = () => {
  return basepathRemover(usePathname() || '')
}

export async function navigate(url: string) {
  const fullUrl = `${configs.FRONT_URL}${url}`
  console.log({ fullUrl })
  NextResponse.redirect(new URL(fullUrl))
}
